import Cookies from 'js-cookie';

function customSessionStorage(exdays, prefix) {
    this.exdays = exdays;
    this.prefix = prefix;
    this.setItem = function (cname, cvalue) {
        /*var d = new Date();
        d.setTime(d.getTime() + (this.exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = this.prefix + cname + "=" + cvalue + ";" + expires + ";path=/";
        */
        Cookies.set(this.prefix + cname, cvalue, { expires: this.exdays, path: '/' });
    };
    this.getItem = function (cname) {
        /*
        var name = this.prefix + cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
        */
        return Cookies.get(this.prefix + cname);
    };
    this.removeItem = function (cname) {
        /*
        var d = new Date(); //Create an date object
        d.setTime(d.getTime() - (1000*60*60*24)); //Set the time to the past. 1000 milliseonds = 1 second
        var expires = "expires=" + d.toGMTString(); //Compose the expirartion date
        window.document.cookie = this.prefix + cname+"="+"; "+expires;//Set the cookie with name and the expiration date
        */
        Cookies.remove(this.prefix + cname);
    };

    this.clear = function () {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            if (cookie.indexOf(name) == 0 && name.indexOf(this.prefix) == 1) {
                //document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                Cookies.remove(name);
            }
        }
    };
}
window.customSessionStorage = sessionStorage; //new customSessionStorage(1,'session_');
window.customLocalStorage = localStorage; //new customSessionStorage(1000,'local_');


//////////////////
// WEBPACK FOOTER
// ./plugins/session-local-storage.js
// module id = ./plugins/session-local-storage.js
// module chunks = 54